/**
 * Home buy box — keeps the add-to-cart button pointing at the selected pack.
 * The actual AJAX add + cart-drawer opening is handled by adv-atc.js, which
 * reads `data-adv-atc` at click time.
 */
if (!customElements.get('home-buybox')) {
  customElements.define(
    'home-buybox',
    class extends HTMLElement {
      connectedCallback() {
        this._onChange = (event) => {
          const radio = event.target.closest('.hbb__radio');
          if (!radio) return;
          const id = radio.dataset.variantId;
          const button = this.querySelector('[data-hbb-atc]');
          if (id && button) {
            button.dataset.advAtc = id;
            button.setAttribute(
              'href',
              `${(window.Shopify?.routes?.root || '/')}cart/add?id=${id}&quantity=1&return_to=/cart`
            );
          }
          this.querySelectorAll('.hbb__row').forEach((row) => {
            row.classList.toggle('is-selected', row.contains(radio));
          });
        };
        this.addEventListener('change', this._onChange);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this._onChange);
      }
    }
  );
}
